/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateDiscoveryRequest,
    CreateDiscoveryRequestFromJSON,
    CreateDiscoveryRequestToJSON,
    CreateSupplementalResponseRequest,
    CreateSupplementalResponseRequestFromJSON,
    CreateSupplementalResponseRequestToJSON,
    Document,
    DocumentFromJSON,
    DocumentToJSON,
    DocumentAccessToken,
    DocumentAccessTokenFromJSON,
    DocumentAccessTokenToJSON,
    DocumentAction,
    DocumentActionFromJSON,
    DocumentActionToJSON,
    DocumentDetail,
    DocumentDetailFromJSON,
    DocumentDetailToJSON,
    DocumentItemPage,
    DocumentItemPageFromJSON,
    DocumentItemPageToJSON,
    DocumentSortableColumns,
    DocumentSortableColumnsFromJSON,
    DocumentSortableColumnsToJSON,
    DocumentSubType,
    DocumentSubTypeFromJSON,
    DocumentSubTypeToJSON,
    DocumentType,
    DocumentTypeFromJSON,
    DocumentTypeToJSON,
    ExternalFile,
    ExternalFileFromJSON,
    ExternalFileToJSON,
    GeneratedInsightBase,
    GeneratedInsightBaseFromJSON,
    GeneratedInsightBaseToJSON,
    IncludedDocuments,
    IncludedDocumentsFromJSON,
    IncludedDocumentsToJSON,
    Interrogatory,
    InterrogatoryFromJSON,
    InterrogatoryToJSON,
    InterrogatoryQuery,
    InterrogatoryQueryFromJSON,
    InterrogatoryQueryToJSON,
    Languages,
    LanguagesFromJSON,
    LanguagesToJSON,
    PostResponsiveFileRequest,
    PostResponsiveFileRequestFromJSON,
    PostResponsiveFileRequestToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PutResponsiveFileRequest,
    PutResponsiveFileRequestFromJSON,
    PutResponsiveFileRequestToJSON,
    ResponsiveFile,
    ResponsiveFileFromJSON,
    ResponsiveFileToJSON,
    ResponsiveFileMap,
    ResponsiveFileMapFromJSON,
    ResponsiveFileMapToJSON,
    SimilarRequest,
    SimilarRequestFromJSON,
    SimilarRequestToJSON,
    Source,
    SourceFromJSON,
    SourceToJSON,
    SupplementalInterrogatoryResponseDetails,
    SupplementalInterrogatoryResponseDetailsFromJSON,
    SupplementalInterrogatoryResponseDetailsToJSON,
    UpdateInterrogatory,
    UpdateInterrogatoryFromJSON,
    UpdateInterrogatoryToJSON,
} from '../models';

export interface DocumentAddInterrogatoryRequest {
    documentId: string;
    updateInterrogatory?: UpdateInterrogatory;
}

export interface DocumentAddResponsiveFileToDocumentRequest {
    documentId: string;
    interrogatoryId: number;
    postResponsiveFileRequest?: PostResponsiveFileRequest;
}

export interface DocumentArchiveRequest {
    documentId: string;
}

export interface DocumentClearMissingFormInterrogatoryRequest {
    documentId: string;
}

export interface DocumentCreateDiscoveryRequestRequest {
    createDiscoveryRequest?: CreateDiscoveryRequest;
}

export interface DocumentCreateQueryForInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentCreateSupplementalResponseRequest {
    documentId: string;
    createSupplementalResponseRequest: CreateSupplementalResponseRequest;
}

export interface DocumentDeleteRequest {
    documentId: string;
}

export interface DocumentDeleteInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentDismissAlertRequest {
    documentId: string;
}

export interface DocumentDismissMismatchWarningRequest {
    documentId: string;
}

export interface DocumentExternalFilesRequest {
    caseId: string;
    externalFile: Array<ExternalFile>;
    clientId?: string;
}

export interface DocumentFindSimilarRequestsForInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentGenerateAccessTokenRequest {
    documentId: string;
}

export interface DocumentGenerateDocumentRequest {
    documentId: string;
    upload?: boolean;
    uploadLocation?: string;
    onlyIncludeSupplementalRogs?: boolean;
}

export interface DocumentGenerateDocumentDownloadRequest {
    documentId: string;
    onlyIncludeSupplementalRogs?: boolean;
}

export interface DocumentGenerateDocumentFromAccessTokenRequest {
    documentId?: string;
    tokenId?: string;
    upload?: boolean;
    onlyIncludeSupplementalRogs?: boolean;
}

export interface DocumentGetRequest {
    documentId: string;
}

export interface DocumentGetAllPagedRequest {
    itemsPerPage?: number;
    pageNumber?: number;
    source?: Source;
    search?: string;
    sortBy?: DocumentSortableColumns;
}

export interface DocumentGetCaseDocumentsRequest {
    caseId: string;
    includedDocuments?: IncludedDocuments;
    source?: Source;
}

export interface DocumentGetInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentGetInterrogatoryQueryRequest {
    documentId: string;
    interrogatoryId: number;
    queryId: string;
}

export interface DocumentGetLatestQueryForInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentGetListRequest {
    userId?: string;
    includedDocuments?: IncludedDocuments;
    source?: Source;
    parentDocumentId?: string;
}

export interface DocumentGetPdfUrlRequest {
    documentId: string;
}

export interface DocumentGetResponsiveFileMapForCaseInterrogatoriesRequest {
    documentId: string;
}

export interface DocumentGetResponsiveFilesForInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentGetSuggestionsRequest {
    documentId: string;
}

export interface DocumentGetSupplementalInterrogatoryResponsesRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentGetUsageCountRequest {
    userId: string;
}

export interface DocumentPostRequest {
    caseId?: string;
    docType?: DocumentType;
    docSubType?: DocumentSubType;
    files?: Array<Blob>;
}

export interface DocumentPutDiscoveryRequestRequest {
    documentId: string;
    createDiscoveryRequest?: CreateDiscoveryRequest;
}

export interface DocumentRateObjectionTextRequest {
    documentId: string;
    interrogatoryId: number;
    objectionId: number;
    body?: number;
}

export interface DocumentRestoreRequest {
    documentId: string;
}

export interface DocumentReuploadDocumentRequest {
    documentId: string;
    caseId?: string;
}

export interface DocumentStartGenerateRequestsRequest {
    createDiscoveryRequest?: CreateDiscoveryRequest;
}

export interface DocumentSuggestObjectionTextRequest {
    documentId: string;
    interrogatoryId: number;
    objectionId: number;
}

export interface DocumentSuggestObjectionsForAllRequest {
    documentId: string;
}

export interface DocumentSuggestObjectionsForInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
}

export interface DocumentTranslateToPlainRequest {
    documentId: string;
    interrogatoryId: number;
    language?: Languages;
}

export interface DocumentTriggerActionRequest {
    documentId: string;
    todo: DocumentAction;
}

export interface DocumentTriggerParseRequest {
    documentId: string;
    startAt?: number;
    endAt?: number;
    forceOCR?: boolean;
}

export interface DocumentUpdateDocumentRequest {
    documentId: string;
    document?: Document;
}

export interface DocumentUpdateDocumentViewedRequest {
    documentId: string;
}

export interface DocumentUpdateInterrogatoryRequest {
    documentId: string;
    interrogatoryId: number;
    updateInterrogatory?: UpdateInterrogatory;
}

export interface DocumentUpdateResponsiveFileRequest {
    documentId: string;
    responsiveFileId: string;
    putResponsiveFileRequest?: PutResponsiveFileRequest;
}

export interface DocumentVerifyResponsiveFilesForInterrogatoryRequest {
    documentId: string;
    id: number;
    verify?: boolean;
}

export interface DocumentVerifyResponsiveFilesForInterrogatoryQueryRequest {
    documentId: string;
    queryId: string;
    verify?: boolean;
}

/**
 * 
 */
export class DocumentApi extends runtime.BaseAPI {

    /**
     */
    async documentAddInterrogatoryRaw(requestParameters: DocumentAddInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentAddInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInterrogatoryToJSON(requestParameters.updateInterrogatory),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentAddInterrogatory(requestParameters: DocumentAddInterrogatoryRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentAddInterrogatoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentAddResponsiveFileToDocumentRaw(requestParameters: DocumentAddResponsiveFileToDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ResponsiveFile>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentAddResponsiveFileToDocument.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentAddResponsiveFileToDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/responsive-file`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostResponsiveFileRequestToJSON(requestParameters.postResponsiveFileRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsiveFileFromJSON(jsonValue));
    }

    /**
     */
    async documentAddResponsiveFileToDocument(requestParameters: DocumentAddResponsiveFileToDocumentRequest, initOverrides?: RequestInit): Promise<ResponsiveFile> {
        const response = await this.documentAddResponsiveFileToDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentArchiveRaw(requestParameters: DocumentArchiveRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentArchive.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/archive`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     */
    async documentArchive(requestParameters: DocumentArchiveRequest, initOverrides?: RequestInit): Promise<Document> {
        const response = await this.documentArchiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentClearMissingFormInterrogatoryRaw(requestParameters: DocumentClearMissingFormInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentClearMissingFormInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/ClearMissingFormInterrogatory`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentClearMissingFormInterrogatory(requestParameters: DocumentClearMissingFormInterrogatoryRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentClearMissingFormInterrogatoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentCreateDiscoveryRequestRaw(requestParameters: DocumentCreateDiscoveryRequestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentDetail>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/DiscoveryRequest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDiscoveryRequestToJSON(requestParameters.createDiscoveryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailFromJSON(jsonValue));
    }

    /**
     */
    async documentCreateDiscoveryRequest(requestParameters: DocumentCreateDiscoveryRequestRequest, initOverrides?: RequestInit): Promise<DocumentDetail> {
        const response = await this.documentCreateDiscoveryRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentCreateQueryForInterrogatoryRaw(requestParameters: DocumentCreateQueryForInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InterrogatoryQuery>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentCreateQueryForInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentCreateQueryForInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/query`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterrogatoryQueryFromJSON(jsonValue));
    }

    /**
     */
    async documentCreateQueryForInterrogatory(requestParameters: DocumentCreateQueryForInterrogatoryRequest, initOverrides?: RequestInit): Promise<InterrogatoryQuery> {
        const response = await this.documentCreateQueryForInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentCreateSupplementalResponseRaw(requestParameters: DocumentCreateSupplementalResponseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentDetail>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentCreateSupplementalResponse.');
        }

        if (requestParameters.createSupplementalResponseRequest === null || requestParameters.createSupplementalResponseRequest === undefined) {
            throw new runtime.RequiredError('createSupplementalResponseRequest','Required parameter requestParameters.createSupplementalResponseRequest was null or undefined when calling documentCreateSupplementalResponse.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/supplemental`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSupplementalResponseRequestToJSON(requestParameters.createSupplementalResponseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailFromJSON(jsonValue));
    }

    /**
     */
    async documentCreateSupplementalResponse(requestParameters: DocumentCreateSupplementalResponseRequest, initOverrides?: RequestInit): Promise<DocumentDetail> {
        const response = await this.documentCreateSupplementalResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentDeleteRaw(requestParameters: DocumentDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentDelete(requestParameters: DocumentDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentDeleteInterrogatoryRaw(requestParameters: DocumentDeleteInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentDeleteInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentDeleteInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentDeleteInterrogatory(requestParameters: DocumentDeleteInterrogatoryRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentDeleteInterrogatoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentDismissAlertRaw(requestParameters: DocumentDismissAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentDismissAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/dismiss-alert`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentDismissAlert(requestParameters: DocumentDismissAlertRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentDismissAlertRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentDismissMismatchWarningRaw(requestParameters: DocumentDismissMismatchWarningRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentDismissMismatchWarning.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/dismiss-mismatch-warning`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentDismissMismatchWarning(requestParameters: DocumentDismissMismatchWarningRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentDismissMismatchWarningRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentExternalFilesRaw(requestParameters: DocumentExternalFilesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling documentExternalFiles.');
        }

        if (requestParameters.externalFile === null || requestParameters.externalFile === undefined) {
            throw new runtime.RequiredError('externalFile','Required parameter requestParameters.externalFile was null or undefined when calling documentExternalFiles.');
        }

        const queryParameters: any = {};

        if (requestParameters.caseId !== undefined) {
            queryParameters['caseId'] = requestParameters.caseId;
        }

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/external-files`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.externalFile.map(ExternalFileToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentExternalFiles(requestParameters: DocumentExternalFilesRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentExternalFilesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentFindSimilarRequestsForInterrogatoryRaw(requestParameters: DocumentFindSimilarRequestsForInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SimilarRequest>>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentFindSimilarRequestsForInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentFindSimilarRequestsForInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/similar-requests`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SimilarRequestFromJSON));
    }

    /**
     */
    async documentFindSimilarRequestsForInterrogatory(requestParameters: DocumentFindSimilarRequestsForInterrogatoryRequest, initOverrides?: RequestInit): Promise<Array<SimilarRequest>> {
        const response = await this.documentFindSimilarRequestsForInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGenerateAccessTokenRaw(requestParameters: DocumentGenerateAccessTokenRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentAccessToken>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGenerateAccessToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/generate-access-token`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentAccessTokenFromJSON(jsonValue));
    }

    /**
     */
    async documentGenerateAccessToken(requestParameters: DocumentGenerateAccessTokenRequest, initOverrides?: RequestInit): Promise<DocumentAccessToken> {
        const response = await this.documentGenerateAccessTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGenerateDocumentRaw(requestParameters: DocumentGenerateDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGenerateDocument.');
        }

        const queryParameters: any = {};

        if (requestParameters.upload !== undefined) {
            queryParameters['upload'] = requestParameters.upload;
        }

        if (requestParameters.uploadLocation !== undefined) {
            queryParameters['uploadLocation'] = requestParameters.uploadLocation;
        }

        if (requestParameters.onlyIncludeSupplementalRogs !== undefined) {
            queryParameters['onlyIncludeSupplementalRogs'] = requestParameters.onlyIncludeSupplementalRogs;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/generate-doc`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async documentGenerateDocument(requestParameters: DocumentGenerateDocumentRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.documentGenerateDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGenerateDocumentDownloadRaw(requestParameters: DocumentGenerateDocumentDownloadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGenerateDocumentDownload.');
        }

        const queryParameters: any = {};

        if (requestParameters.onlyIncludeSupplementalRogs !== undefined) {
            queryParameters['onlyIncludeSupplementalRogs'] = requestParameters.onlyIncludeSupplementalRogs;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/generate-doc-download`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async documentGenerateDocumentDownload(requestParameters: DocumentGenerateDocumentDownloadRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.documentGenerateDocumentDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGenerateDocumentFromAccessTokenRaw(requestParameters: DocumentGenerateDocumentFromAccessTokenRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        if (requestParameters.tokenId !== undefined) {
            queryParameters['tokenId'] = requestParameters.tokenId;
        }

        if (requestParameters.upload !== undefined) {
            queryParameters['upload'] = requestParameters.upload;
        }

        if (requestParameters.onlyIncludeSupplementalRogs !== undefined) {
            queryParameters['onlyIncludeSupplementalRogs'] = requestParameters.onlyIncludeSupplementalRogs;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/generate-doc-accesstoken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async documentGenerateDocumentFromAccessToken(requestParameters: DocumentGenerateDocumentFromAccessTokenRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.documentGenerateDocumentFromAccessTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetRaw(requestParameters: DocumentGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentDetail>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailFromJSON(jsonValue));
    }

    /**
     */
    async documentGet(requestParameters: DocumentGetRequest, initOverrides?: RequestInit): Promise<DocumentDetail> {
        const response = await this.documentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetAllPagedRaw(requestParameters: DocumentGetAllPagedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentItemPage>> {
        const queryParameters: any = {};

        if (requestParameters.itemsPerPage !== undefined) {
            queryParameters['itemsPerPage'] = requestParameters.itemsPerPage;
        }

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.source !== undefined) {
            queryParameters['source'] = requestParameters.source;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/all/paged`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentItemPageFromJSON(jsonValue));
    }

    /**
     */
    async documentGetAllPaged(requestParameters: DocumentGetAllPagedRequest, initOverrides?: RequestInit): Promise<DocumentItemPage> {
        const response = await this.documentGetAllPagedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetCaseDocumentsRaw(requestParameters: DocumentGetCaseDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Document>>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling documentGetCaseDocuments.');
        }

        const queryParameters: any = {};

        if (requestParameters.includedDocuments !== undefined) {
            queryParameters['includedDocuments'] = requestParameters.includedDocuments;
        }

        if (requestParameters.source !== undefined) {
            queryParameters['source'] = requestParameters.source;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/case/{caseId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     */
    async documentGetCaseDocuments(requestParameters: DocumentGetCaseDocumentsRequest, initOverrides?: RequestInit): Promise<Array<Document>> {
        const response = await this.documentGetCaseDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetInterrogatoryRaw(requestParameters: DocumentGetInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Interrogatory>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentGetInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterrogatoryFromJSON(jsonValue));
    }

    /**
     */
    async documentGetInterrogatory(requestParameters: DocumentGetInterrogatoryRequest, initOverrides?: RequestInit): Promise<Interrogatory> {
        const response = await this.documentGetInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetInterrogatoryQueryRaw(requestParameters: DocumentGetInterrogatoryQueryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InterrogatoryQuery>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetInterrogatoryQuery.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentGetInterrogatoryQuery.');
        }

        if (requestParameters.queryId === null || requestParameters.queryId === undefined) {
            throw new runtime.RequiredError('queryId','Required parameter requestParameters.queryId was null or undefined when calling documentGetInterrogatoryQuery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/query/{queryId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))).replace(`{${"queryId"}}`, encodeURIComponent(String(requestParameters.queryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterrogatoryQueryFromJSON(jsonValue));
    }

    /**
     */
    async documentGetInterrogatoryQuery(requestParameters: DocumentGetInterrogatoryQueryRequest, initOverrides?: RequestInit): Promise<InterrogatoryQuery> {
        const response = await this.documentGetInterrogatoryQueryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetLatestQueryForInterrogatoryRaw(requestParameters: DocumentGetLatestQueryForInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InterrogatoryQuery>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetLatestQueryForInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentGetLatestQueryForInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/query/latest`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterrogatoryQueryFromJSON(jsonValue));
    }

    /**
     */
    async documentGetLatestQueryForInterrogatory(requestParameters: DocumentGetLatestQueryForInterrogatoryRequest, initOverrides?: RequestInit): Promise<InterrogatoryQuery> {
        const response = await this.documentGetLatestQueryForInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetListRaw(requestParameters: DocumentGetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Document>>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.includedDocuments !== undefined) {
            queryParameters['includedDocuments'] = requestParameters.includedDocuments;
        }

        if (requestParameters.source !== undefined) {
            queryParameters['source'] = requestParameters.source;
        }

        if (requestParameters.parentDocumentId !== undefined) {
            queryParameters['parentDocumentId'] = requestParameters.parentDocumentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     */
    async documentGetList(requestParameters: DocumentGetListRequest, initOverrides?: RequestInit): Promise<Array<Document>> {
        const response = await this.documentGetListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetPdfUrlRaw(requestParameters: DocumentGetPdfUrlRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetPdfUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/getpdfurl`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async documentGetPdfUrl(requestParameters: DocumentGetPdfUrlRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.documentGetPdfUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetResponsiveFileMapForCaseInterrogatoriesRaw(requestParameters: DocumentGetResponsiveFileMapForCaseInterrogatoriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ResponsiveFileMap>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetResponsiveFileMapForCaseInterrogatories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/responsive-file-map`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsiveFileMapFromJSON(jsonValue));
    }

    /**
     */
    async documentGetResponsiveFileMapForCaseInterrogatories(requestParameters: DocumentGetResponsiveFileMapForCaseInterrogatoriesRequest, initOverrides?: RequestInit): Promise<ResponsiveFileMap> {
        const response = await this.documentGetResponsiveFileMapForCaseInterrogatoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetResponsiveFilesForInterrogatoryRaw(requestParameters: DocumentGetResponsiveFilesForInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ResponsiveFile>>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetResponsiveFilesForInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentGetResponsiveFilesForInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/responsive-files`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponsiveFileFromJSON));
    }

    /**
     */
    async documentGetResponsiveFilesForInterrogatory(requestParameters: DocumentGetResponsiveFilesForInterrogatoryRequest, initOverrides?: RequestInit): Promise<Array<ResponsiveFile>> {
        const response = await this.documentGetResponsiveFilesForInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetSuggestionsRaw(requestParameters: DocumentGetSuggestionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<GeneratedInsightBase>>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetSuggestions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/suggestions`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GeneratedInsightBaseFromJSON));
    }

    /**
     */
    async documentGetSuggestions(requestParameters: DocumentGetSuggestionsRequest, initOverrides?: RequestInit): Promise<Array<GeneratedInsightBase>> {
        const response = await this.documentGetSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetSupplementalInterrogatoryResponsesRaw(requestParameters: DocumentGetSupplementalInterrogatoryResponsesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SupplementalInterrogatoryResponseDetails>>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentGetSupplementalInterrogatoryResponses.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentGetSupplementalInterrogatoryResponses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/supplemental-responses`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupplementalInterrogatoryResponseDetailsFromJSON));
    }

    /**
     */
    async documentGetSupplementalInterrogatoryResponses(requestParameters: DocumentGetSupplementalInterrogatoryResponsesRequest, initOverrides?: RequestInit): Promise<Array<SupplementalInterrogatoryResponseDetails>> {
        const response = await this.documentGetSupplementalInterrogatoryResponsesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentGetUsageCountRaw(requestParameters: DocumentGetUsageCountRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling documentGetUsageCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/usage-count/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async documentGetUsageCount(requestParameters: DocumentGetUsageCountRequest, initOverrides?: RequestInit): Promise<number> {
        const response = await this.documentGetUsageCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentPostRaw(requestParameters: DocumentPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Document>>> {
        const queryParameters: any = {};

        if (requestParameters.caseId !== undefined) {
            queryParameters['caseId'] = requestParameters.caseId;
        }

        if (requestParameters.docType !== undefined) {
            queryParameters['docType'] = requestParameters.docType;
        }

        if (requestParameters.docSubType !== undefined) {
            queryParameters['docSubType'] = requestParameters.docSubType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.files) {
            requestParameters.files.forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        const response = await this.request({
            path: `/api/Document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     */
    async documentPost(requestParameters: DocumentPostRequest, initOverrides?: RequestInit): Promise<Array<Document>> {
        const response = await this.documentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentPutDiscoveryRequestRaw(requestParameters: DocumentPutDiscoveryRequestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentDetail>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentPutDiscoveryRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/DiscoveryRequest`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDiscoveryRequestToJSON(requestParameters.createDiscoveryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailFromJSON(jsonValue));
    }

    /**
     */
    async documentPutDiscoveryRequest(requestParameters: DocumentPutDiscoveryRequestRequest, initOverrides?: RequestInit): Promise<DocumentDetail> {
        const response = await this.documentPutDiscoveryRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentRateObjectionTextRaw(requestParameters: DocumentRateObjectionTextRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentRateObjectionText.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentRateObjectionText.');
        }

        if (requestParameters.objectionId === null || requestParameters.objectionId === undefined) {
            throw new runtime.RequiredError('objectionId','Required parameter requestParameters.objectionId was null or undefined when calling documentRateObjectionText.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/suggest-objection-text/{objectionId}/rate`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))).replace(`{${"objectionId"}}`, encodeURIComponent(String(requestParameters.objectionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentRateObjectionText(requestParameters: DocumentRateObjectionTextRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentRateObjectionTextRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentRestoreRaw(requestParameters: DocumentRestoreRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentRestore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/restore`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     */
    async documentRestore(requestParameters: DocumentRestoreRequest, initOverrides?: RequestInit): Promise<Document> {
        const response = await this.documentRestoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentReuploadDocumentRaw(requestParameters: DocumentReuploadDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentReuploadDocument.');
        }

        const queryParameters: any = {};

        if (requestParameters.caseId !== undefined) {
            queryParameters['caseId'] = requestParameters.caseId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/re-upload`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentReuploadDocument(requestParameters: DocumentReuploadDocumentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentReuploadDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentStartGenerateRequestsRaw(requestParameters: DocumentStartGenerateRequestsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/start-generate-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDiscoveryRequestToJSON(requestParameters.createDiscoveryRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentStartGenerateRequests(requestParameters: DocumentStartGenerateRequestsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentStartGenerateRequestsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentSuggestObjectionTextRaw(requestParameters: DocumentSuggestObjectionTextRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentSuggestObjectionText.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentSuggestObjectionText.');
        }

        if (requestParameters.objectionId === null || requestParameters.objectionId === undefined) {
            throw new runtime.RequiredError('objectionId','Required parameter requestParameters.objectionId was null or undefined when calling documentSuggestObjectionText.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/suggest-objection-text/{objectionId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))).replace(`{${"objectionId"}}`, encodeURIComponent(String(requestParameters.objectionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async documentSuggestObjectionText(requestParameters: DocumentSuggestObjectionTextRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.documentSuggestObjectionTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentSuggestObjectionsForAllRaw(requestParameters: DocumentSuggestObjectionsForAllRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentSuggestObjectionsForAll.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/auto-object`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentSuggestObjectionsForAll(requestParameters: DocumentSuggestObjectionsForAllRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentSuggestObjectionsForAllRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentSuggestObjectionsForInterrogatoryRaw(requestParameters: DocumentSuggestObjectionsForInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentSuggestObjectionsForInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentSuggestObjectionsForInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/suggested-objections`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async documentSuggestObjectionsForInterrogatory(requestParameters: DocumentSuggestObjectionsForInterrogatoryRequest, initOverrides?: RequestInit): Promise<Array<number>> {
        const response = await this.documentSuggestObjectionsForInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentTranslateToPlainRaw(requestParameters: DocumentTranslateToPlainRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentTranslateToPlain.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentTranslateToPlain.');
        }

        const queryParameters: any = {};

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}/plain`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async documentTranslateToPlain(requestParameters: DocumentTranslateToPlainRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.documentTranslateToPlainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentTriggerActionRaw(requestParameters: DocumentTriggerActionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentTriggerAction.');
        }

        if (requestParameters.todo === null || requestParameters.todo === undefined) {
            throw new runtime.RequiredError('todo','Required parameter requestParameters.todo was null or undefined when calling documentTriggerAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/trigger-action/{todo}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"todo"}}`, encodeURIComponent(String(requestParameters.todo))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentTriggerAction(requestParameters: DocumentTriggerActionRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentTriggerActionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentTriggerParseRaw(requestParameters: DocumentTriggerParseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentTriggerParse.');
        }

        const queryParameters: any = {};

        if (requestParameters.startAt !== undefined) {
            queryParameters['startAt'] = requestParameters.startAt;
        }

        if (requestParameters.endAt !== undefined) {
            queryParameters['endAt'] = requestParameters.endAt;
        }

        if (requestParameters.forceOCR !== undefined) {
            queryParameters['forceOCR'] = requestParameters.forceOCR;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/parse`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentTriggerParse(requestParameters: DocumentTriggerParseRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentTriggerParseRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentUpdateDocumentRaw(requestParameters: DocumentUpdateDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DocumentDetail>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentUpdateDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentToJSON(requestParameters.document),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailFromJSON(jsonValue));
    }

    /**
     */
    async documentUpdateDocument(requestParameters: DocumentUpdateDocumentRequest, initOverrides?: RequestInit): Promise<DocumentDetail> {
        const response = await this.documentUpdateDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentUpdateDocumentViewedRaw(requestParameters: DocumentUpdateDocumentViewedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentUpdateDocumentViewed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/viewed`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentUpdateDocumentViewed(requestParameters: DocumentUpdateDocumentViewedRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentUpdateDocumentViewedRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentUpdateInterrogatoryRaw(requestParameters: DocumentUpdateInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentUpdateInterrogatory.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling documentUpdateInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{interrogatoryId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInterrogatoryToJSON(requestParameters.updateInterrogatory),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentUpdateInterrogatory(requestParameters: DocumentUpdateInterrogatoryRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentUpdateInterrogatoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentUpdateResponsiveFileRaw(requestParameters: DocumentUpdateResponsiveFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentUpdateResponsiveFile.');
        }

        if (requestParameters.responsiveFileId === null || requestParameters.responsiveFileId === undefined) {
            throw new runtime.RequiredError('responsiveFileId','Required parameter requestParameters.responsiveFileId was null or undefined when calling documentUpdateResponsiveFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/responsive-file/{responsiveFileId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"responsiveFileId"}}`, encodeURIComponent(String(requestParameters.responsiveFileId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutResponsiveFileRequestToJSON(requestParameters.putResponsiveFileRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentUpdateResponsiveFile(requestParameters: DocumentUpdateResponsiveFileRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentUpdateResponsiveFileRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentVerifyResponsiveFilesForInterrogatoryRaw(requestParameters: DocumentVerifyResponsiveFilesForInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentVerifyResponsiveFilesForInterrogatory.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling documentVerifyResponsiveFilesForInterrogatory.');
        }

        const queryParameters: any = {};

        if (requestParameters.verify !== undefined) {
            queryParameters['verify'] = requestParameters.verify;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory/{id}/verify-responsive-files`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentVerifyResponsiveFilesForInterrogatory(requestParameters: DocumentVerifyResponsiveFilesForInterrogatoryRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentVerifyResponsiveFilesForInterrogatoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentVerifyResponsiveFilesForInterrogatoryQueryRaw(requestParameters: DocumentVerifyResponsiveFilesForInterrogatoryQueryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling documentVerifyResponsiveFilesForInterrogatoryQuery.');
        }

        if (requestParameters.queryId === null || requestParameters.queryId === undefined) {
            throw new runtime.RequiredError('queryId','Required parameter requestParameters.queryId was null or undefined when calling documentVerifyResponsiveFilesForInterrogatoryQuery.');
        }

        const queryParameters: any = {};

        if (requestParameters.verify !== undefined) {
            queryParameters['verify'] = requestParameters.verify;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Document/{documentId}/interrogatory-query/{queryId}/verify-responsive-files`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"queryId"}}`, encodeURIComponent(String(requestParameters.queryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentVerifyResponsiveFilesForInterrogatoryQuery(requestParameters: DocumentVerifyResponsiveFilesForInterrogatoryQueryRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentVerifyResponsiveFilesForInterrogatoryQueryRaw(requestParameters, initOverrides);
    }

}
